import React, { useEffect, useState } from 'react';
import {
	Grid,
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Divider,
	Typography,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Checkbox } from '@mui/joy';
import CustomRadioGroup from 'src/components/CustomRadioGroup';
import validateColor from '../../../../utils/colorValidation';
import TagComponent from 'src/components/Tag';
import Input from 'src/components/Input';

const INIT_FORM_DATE = {
	name: '',
	translationKey: '',
	translationDefault: '',
	textColor: '',
	textSize: '',
	gradient: '',
	modal: {
		descriptionDefault: '',
		descriptionKey: '',
		textIcon: '',
		titleDefault: '',
		titleKey: '',
	},
};
const INIT_ERRORS = {
	name: '',
};
const AddLabel = ({ isVisible, onClose, onCreate, existingFormData }) => {
	const theme = useTheme();

	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const isUpdate = Object.keys(existingFormData || {}).length !== 0;

	const [errors, setErrors] = useState(INIT_ERRORS);
	const [formData, setFormData] = useState(INIT_FORM_DATE);
	const [showModelFields, setShowModelFields] = useState(false);

	useEffect(() => {
		if (existingFormData) {
			setFormData(existingFormData);
			setShowModelFields(!!existingFormData.modal);
		}
	}, [existingFormData]);

	const handleCloseModal = () => {
		setErrors(INIT_ERRORS);
		setFormData(INIT_FORM_DATE);
		onClose(false);
	};

	const validateField = (name, value) => {
		switch (name) {
			case 'name':
				setErrors((prevState) => ({
					...prevState,
					name: value ? '' : 'Label name is required.',
				}));
				break;
			case 'translationKey':
				setErrors((prevState) => ({
					...prevState,
					name: value ? '' : 'Translation key is required.',
				}));
				break;
			case 'translationDefault':
				setErrors((prevState) => ({
					...prevState,
					name: value ? '' : 'Translation Default is required.',
				}));
				break;
			case 'textColor':
				setErrors((prevState) => ({
					...prevState,
					textColor: validateColor(value) ? '' : 'Invalid color code.',
				}));
				break;
			default:
				break;
		}
	};

	const handleInputChange = (event) => {
		const { id, value, type } = event.target;

		if (type === 'radio') {
			setFormData((prevState) => ({
				...prevState,
				isTextCap: value === 'true',
			}));
		} else {
			setFormData((prevState) => ({
				...prevState,
				[id]: value,
			}));
		}

		validateField(id, value);
	};

	const inputPropsHandlers = {
		onChangeBlur: handleInputChange,
	};

	// const inputProps = {
	// 	required: true,
	// 	fullWidth: true,
	// 	margin: 'normal',
	// 	onChange: handleInputChange,
	// };

	// const handleModalInputChange = (event) => {
	// 	const { id, value } = event.target;
	// 	setFormData((prevState) => ({
	// 		...prevState,
	// 		modal: {
	// 			...prevState.modal,
	// 			[id]: value,
	// 		},
	// 	}));
	// 	validateField(id, value);
	// };

	// const modalInputProps = {
	// 	...inputProps,
	// 	onChange: handleModalInputChange,
	// };

	const onCreateHandler = () => {
		const items = Object.keys(formData);
		items.forEach((item) => {
			validateField(item, formData[item]);
		});

		const allFieldsOk = Object.values(errors).every((x) => x === null || x === '');
		console.log({ allFieldsOk, errors });

		const updateFormData = {
			...formData,
			modal: showModelFields ? { ...formData.modal } : null,
		};
		if (allFieldsOk) {
			onCreate({ ...updateFormData, isUpdate });
			handleCloseModal();
		}
	};

	const handleCheckboxChange = (event) => {
		if (!!existingFormData && !!existingFormData.modal) {
			setFormData({ ...formData, modal: existingFormData.modal });
		} else {
			setFormData({ ...formData, modal: INIT_FORM_DATE.modal });
		}
		setShowModelFields(event.target.checked);
	};

	const handleSelectedOptionsChange = (selectedOptions) => {
		setFormData({ ...formData, isTextCap: selectedOptions.toLowerCase() === 'true' ? true : false });
	};

	return (
		<Dialog open={isVisible} onClose={onClose} fullScreen={fullScreen} scroll="paper">
			<DialogTitle id="scroll-dialog-title" onClose={onClose}>
				New Gift Label
			</DialogTitle>
			<DialogContent dividers>
				<Grid container spacing={2}>
					<Grid item>
						<Typography variant="caption" display="block">
							Preview Product Label:
						</Typography>
						<TagComponent
							tag={{
								name: formData.name,
								gradient: formData.gradient,
								textColor: formData.textColor,
								textSize: formData.textSize,
								isTextCap: formData.isTextCap,
								modal: formData.modal ? { ...formData.modal } : null,
							}}
							showDeleteIcon={false}
						/>
					</Grid>
					<Grid item md={12} xs={12}>
						<Divider />
					</Grid>
					<Grid container item md={12} spacing={2}>
						<Grid item md={12} xs={12}>
							<Input
								{...inputPropsHandlers}
								id="name"
								label="Label name"
								value={formData.name}
								error={errors.name}
							/>
						</Grid>
						<Grid item md={12} xs={12}>
							<Input
								{...inputPropsHandlers}
								id="translationKey"
								label="Translation Key"
								value={formData.translationKey}
								error={errors.translationKey}
							/>
						</Grid>
						<Grid item md={12} xs={12}>
							<Input
								{...inputPropsHandlers}
								id="translationDefault"
								label="Translation Default"
								value={formData.translationDefault}
								error={errors.translationDefault}
							/>
						</Grid>
						<Grid item md={12} xs={12}>
							<Input
								{...inputPropsHandlers}
								id="textColor"
								label={`Text color (${formData.textColor})`}
								value={formData.textColor || null}
								type="color"
								error={errors.textColor}
							/>
						</Grid>
						<Grid item md={12} xs={12}>
							<Input
								{...inputPropsHandlers}
								id="textSize"
								label="Text Size"
								type="number"
								value={formData.textSize}
								error={errors.textSize}
							/>
						</Grid>
						<Grid item md={12} xs={12}>
							<Input
								{...inputPropsHandlers}
								id="gradient"
								label="Gradient"
								value={formData.gradient}
								error={errors.gradient}
							/>
						</Grid>
						<Grid item md={12} xs={12}>
							<CustomRadioGroup
								onLoad={formData.isTextCap}
								value={formData.isTextCap}
								label="Is Text Capitalized"
								onSelectRadioButton={handleSelectedOptionsChange}
							></CustomRadioGroup>
						</Grid>
						<Grid
							container
							item
							md={12}
							xs={12}
							spacing={2}
							direction="row"
							justifyContent="flex-start"
							alignItems="center"
						>
							<Grid item>
								<Checkbox
									className="checkbox"
									checked={showModelFields}
									onChange={handleCheckboxChange}
								/>
							</Grid>
							<Grid item>
								<Typography variant="body1">Add Modal Information</Typography>
							</Grid>
						</Grid>
						{showModelFields && formData.modal && (
							<Grid container item md={12} xs={12} spacing={2}>
								<Grid item md={12} xs={12}>
									<Input
										{...inputPropsHandlers}
										id="titleKey"
										label="Title Key"
										value={formData.modal.titleKey}
										error={errors.titleKey}
									/>
								</Grid>
								<Grid item md={12} xs={12}>
									<Input
										{...inputPropsHandlers}
										id="titleDefault"
										label="Title Default"
										value={formData.modal.titleDefault}
										error={errors.titleDefault}
									/>
								</Grid>
								<Grid item md={12} xs={12}>
									<Input
										{...inputPropsHandlers}
										id="descriptionKey"
										label="Description Key"
										value={formData.modal.descriptionKey}
										error={errors.descriptionKey}
									/>
								</Grid>
								<Grid item md={12} xs={12}>
									<Input
										{...inputPropsHandlers}
										id="descriptionDefault"
										label="Description Default"
										value={formData.modal.descriptionDefault}
										error={errors.descriptionDefault}
									/>
								</Grid>
								<Grid item md={12} xs={12}>
									<Input
										{...inputPropsHandlers}
										id="descriptionDefault"
										label="Description Default"
										value={formData.modal.descriptionDefault}
										error={errors.descriptionDefault}
									/>
								</Grid>
							</Grid>
						)}
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCloseModal}>Cancel</Button>
				<Button variant="contained" onClick={onCreateHandler} disabled={!formData.name}>
					{isUpdate ? 'Update' : 'Create'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AddLabel;
